import { render, staticRenderFns } from "./ConfirmSnag.vue?vue&type=template&id=1381f88a&scoped=true"
import script from "./ConfirmSnag.vue?vue&type=script&lang=js"
export * from "./ConfirmSnag.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSnag.vue?vue&type=style&index=0&id=1381f88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1381f88a",
  null
  
)

export default component.exports